if (!customElements.get('blog-section')) {
    // js/sections/BlogSection.js
    class BlogSection extends HTMLElement {
        constructor() {
            super();
            this.blogTagSelector = new ValuePicker("blog-tag-selector");
            if (Shopify.designMode) {
            let elementToAdd = this.querySelector(".page__header");
                if (elementToAdd) {
                    document.querySelector(".blog-container").previousElementSibling.remove();
                    document.querySelector(".blog-container").insertAdjacentElement("beforebegin", elementToAdd);
                }
            }
        }
        onUnload() {
            this.blogTagSelector.destroy();
        }
    };

    customElements.define('blog-section', BlogSection);
}